
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import StorySection from './components/StorySection';
import MethodSection from './components/MethodSection';
import ResultsSection from './components/ResultsSection';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: '"Inter", sans-serif' }}>
      <Header />
      <main>
        <AboutHero />
        <StorySection />
        <MethodSection />
        <ResultsSection />
      </main>
      <Footer />
    </div>
  );
}
